import { LazyLoadImage } from 'react-lazy-load-image-component';
import { NavBarUserProps } from './NavBarUserTypes';
import { logOutUser, setShowSignInUp } from '../../../redux/user/user.actions';
import { connect } from 'react-redux';
import User from '../../../assets/User';
import './NavBarUserStyles.scss';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import SignInUp from '../../atoms/Auth/SignInUp/SignInUp';

function NavBarUser({ setShowSignInUp, logOutUser, user, urbainUser }: NavBarUserProps) {
  const history = useHistory();
  const goTo = (where: string) => {
    history.push(where);
  };

  return (
    <div className="nav-bar-user">
      {user || urbainUser ? (
        <div className="user-greet">
          <Dropdown>
            <Dropdown.Toggle
              as={React.forwardRef(({ children, onClick }: any, ref: any) => (
                <div
                  className="name-pic-container"
                  ref={ref}
                  onClick={e => {
                    e.preventDefault();
                    onClick(e);
                  }}
                >
                  <div className="user-name highlight">Welcome, {urbainUser?.FirstName || user?.attributes?.name || user?.username}</div>
                  {urbainUser?.PhotoURL ? (
                    <LazyLoadImage
                      src={urbainUser?.PhotoURL || 'https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg'}
                      className="user-image rounded-circle z-depth-0"
                      alt="avatar"
                    />
                  ) : (
                    <User className="user-image" />
                  )}
                </div>
              ))}
            ></Dropdown.Toggle>
            {/* @ts-ignore */}
            <Dropdown.Menu className={'dropdown-dark'} align={'right'}>
              <Dropdown.Item onClick={() => goTo('/profile')}>My Account</Dropdown.Item>
              <Dropdown.Item onClick={() => goTo('/my-trips')}>My Trips</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => logOutUser(null)}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ) : (
        <>
          <div className="pointer highlight login pr-2 pr-lg-5" onClick={() => setShowSignInUp()}>
            Login
          </div>
          <div className="pointer highlight" onClick={() => setShowSignInUp(true)}>
            Sign Up
          </div>
          <SignInUp />
        </>
      )}
    </div>
  );
}

const mapDispatchToProps = {
  setShowSignInUp,
  logOutUser
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.user,
    urbainUser: state.user.urbainUser
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBarUser);
